<script lang="ts">
	import { openModal } from '$lib/stores/modal';
</script>

<section class="mt-20 border-y border-white/[0.06] py-10 sm:mt-32">
	<div class="mx-auto max-w-[1216px] px-4 lg:px-0">
		<div
			class="flex flex-col items-center justify-center gap-6 text-center md:flex-row md:gap-12 md:text-left"
		>
			<div class="flex items-center gap-3">
				<div
					class="border-blue/30 bg-blue/10 flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full border"
				>
					<svg class="text-blue h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"
						><path
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="1.5"
							d="M13 10V3L4 14h7v7l9-11h-7z"
						/></svg
					>
				</div>
				<div class="text-left">
					<div class="font-display text-sm font-medium text-white/90">Design Partner Program</div>
					<div class="font-display text-xs text-white/50">Now accepting applications</div>
				</div>
			</div>
			<div class="hidden h-12 w-px bg-white/10 md:block"></div>
			<p class="max-w-xl font-display text-sm text-white/70 lg:text-base">
				Work directly with our founding team to shape Admiral. Preferential pricing, white-glove
				onboarding, and first access to new capabilities.
			</p>
			<button
				onclick={openModal}
				class="text-blue-soft flex items-center gap-2 whitespace-nowrap font-display text-sm font-medium transition-colors hover:text-white"
			>
				Apply now
				<svg class="h-4 w-4" viewBox="0 0 16 16" fill="none"
					><path
						d="M6 3l5 5-5 5"
						stroke="currentColor"
						stroke-width="1.5"
						stroke-linecap="round"
					/></svg
				>
			</button>
		</div>
	</div>
</section>
